import api from '../../api'
import {
  GET_COLORS_LIST_SUCCESS,
  GET_COLORS_LIST_FAILURE,
  GET_COLORS_FAILURE,
  GET_COLORS_SUCCESS,
  UPDATE_COLORS_SUCCESS,
} from '../types'

const state = {
  list: [],
  listUpdated: (new Date()),
  toValidateList: [],
  selected: null,
  selectedUpdated: (new Date())
};


const actions = {
  getColorsList({commit}, query) {
    return new Promise((resolve, reject) => {

    api.startLoader()
    api.getColorsList(query).then(response => {
      if (!response.ok) {
        api.stopLoader()
        commit(GET_COLORS_LIST_FAILURE)
        return reject(response.body.$error)

      }
      commit(GET_COLORS_LIST_SUCCESS, {
        colorsList: response.body.data
      })
      api.stopLoader()
      return resolve(response.body.data)

    }, response => {
      api.stopLoader()
      commit(GET_COLORS_LIST_FAILURE)
      return reject(response.body.$error)
    })
  })

  },
 
  cleanColorsList({commit}) {
    return commit(GET_COLORS_LIST_FAILURE)
  },
  getColors({commit}, ud) {
    return new Promise((resolve, reject) => {

      api.getColors(ud)
        .then(response => {
          console.log(response);
          if (!response.ok) {
            commit(GET_COLORS_FAILURE);
            reject();
          }
          commit(GET_COLORS_SUCCESS, {
            colors: response.body
          });
          resolve(response.body);
        }, response => {
          commit(GET_COLORS_FAILURE);
          reject();
        })
    })
  },
 
  
  updateColors({commit}, data) {
    return new Promise((resolve, reject) => {

      api.startLoader()
      let avaliables = [
        "id",
        "name",
        "active"
      ];

      let obj = {};

      for (let i of avaliables) {
        if (data.hasOwnProperty(i)) {
          obj[i] = data[i];
        }
      }
    
          api.updateColors(obj)
            .then(response => {
              if (!response.ok) {
                api.stopLoader()
                return reject(response.body.$error);
              } else {
                api.stopLoader()
                return resolve(response.body.$success);
              }
            }, response => {
              api.stopLoader()
              return reject(response.body.$error);
            })
      
    })
  },


  createColors({commit}, data) {
    return new Promise((resolve, reject) => {
      api.startLoader()
      api.createColors(data)
      .then(response => {
        if (!response.ok) {
          api.stopLoader()
          return reject(response.body.$error);
        } else {
          api.stopLoader()
          return resolve(response.body.$success);
        }
      }, response => {
        api.stopLoader()
        return reject(response.body.$error);
      })
    })
  },
  
  
 
  deleteColors({commit}, data) {
    return new Promise((resolve, reject) => {
      api.startLoader()
      api.deleteColors(data)
         .then(response => {
              if (!response.ok) {
                api.stopLoader()
                return reject(response.body.$error);
              } else {
                api.stopLoader()
                return resolve(response.body.$success);
              }
            }, response => {
              api.stopLoader()
              return reject(response.body.$error);
            })
    })
  },

  
  
};

const mutations = {

  [UPDATE_COLORS_SUCCESS](state, action) {
    state.selected = JSON.parse(JSON.stringify(action.colors));
  },
  [GET_COLORS_LIST_FAILURE](state) {
    state.list = []
  },
  [GET_COLORS_LIST_SUCCESS](state, action) {
    state.list = action.colorsList;
    state.listUpdated = new Date();
  },
  [GET_COLORS_FAILURE](state) {
    state.selected = null
  },
  [GET_COLORS_SUCCESS](state, action) {
    state.selected = JSON.parse(JSON.stringify(action.colors));
  },
};

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/colors.js